import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { ORDER_TYPE } from '../../data/common';
import SuffleIc from '../../assets/images/ic_shuffle.svg';

const VocaOrdering = ({
  orderingCheck,
  setOrderingCheck,
  vocabularyList,
  setVocabularyList,
}) => {
  return (
    <section className="px-[12px] max-h-[47px] h-[47px] flex gap-2 justify-center items-center py-2.5 text-xs font-bold leading-none whitespace-nowrap border-b border-slate-300 w-full">
      <div className="flex justify-between items-center w-full items-center my-auto">
        <div className="max-h-[20px] h-[20px] flex gap-1 text-[14px] font-[400] justify-center items-center self-stretch my-auto rounded-sm">
          <button
            type="button"
            onClick={() => setOrderingCheck(ORDER_TYPE.BOOK)}
            style={{
              color: orderingCheck === ORDER_TYPE.BOOK ? '#773DBD' : '#1E293B',
              fontWeight: orderingCheck === ORDER_TYPE.BOOK ? 700 : 400,
            }}
          >
            교재순서
          </button>
          <div className="font-[600]">&#124;</div>
          <button
            type="button"
            onClick={() => setOrderingCheck(ORDER_TYPE.ALPHABET)}
            style={{
              color:
                orderingCheck === ORDER_TYPE.ALPHABET ? '#773DBD' : '#1E293B',
              fontWeight: orderingCheck === ORDER_TYPE.ALPHABET ? 700 : 400,
            }}
          >
            알파벳순
          </button>
          <div className="font-[600]">&#124;</div>
          <button
            type="button"
            onClick={() => setOrderingCheck(ORDER_TYPE.RANDOM)}
            style={{
              color:
                orderingCheck === ORDER_TYPE.RANDOM ? '#773DBD' : '#1E293B',
              fontWeight: orderingCheck === ORDER_TYPE.RANDOM ? 700 : 400,
            }}
          >
            랜덤순서
          </button>
        </div>
      </div>
      <Button
        variant="gray"
        className="w-[70px] h-[28px] flex gap-1"
        onClick={() => {
          setVocabularyList(
            vocabularyList
              .map(voca => ({
                ...voca,
              }))
              .sort(() => Math.random() - 0.5),
          );
          setOrderingCheck(ORDER_TYPE.RANDOM);
        }}
      >
        <div
          className="text-[#1E293B] font-[700]"
          style={{ fontFamily: 'Pretendard' }}
        >
          셔플
        </div>
        <img src={SuffleIc} alt="suffle" />
      </Button>
    </section>
  );
};

VocaOrdering.propTypes = {
  orderingCheck: PropTypes.number.isRequired,
  setOrderingCheck: PropTypes.func.isRequired,
  vocabularyList: PropTypes.array.isRequired,
  setVocabularyList: PropTypes.func.isRequired,
};

export default React.memo(VocaOrdering);
